import { render, staticRenderFns } from "./ItfVerify.vue?vue&type=template&id=4355b625&scoped=true"
import script from "./ItfVerify.vue?vue&type=script&lang=js"
export * from "./ItfVerify.vue?vue&type=script&lang=js"
import style0 from "./ItfVerify.vue?vue&type=style&index=0&id=4355b625&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4355b625",
  null
  
)

export default component.exports